import { render, staticRenderFns } from "./SUPErrors.vue?vue&type=template&id=47873ec0&scoped=true"
import script from "./SUPErrors.vue?vue&type=script&lang=js"
export * from "./SUPErrors.vue?vue&type=script&lang=js"
import style0 from "./SUPErrors.vue?vue&type=style&index=0&id=47873ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47873ec0",
  null
  
)

export default component.exports